// extracted by mini-css-extract-plugin
export default {"container":"styles_container__grUeG","page_btn":"styles_page_btn__23aV1","active":"styles_active__tbW6l"};